import React from 'react';
import StarContainer from './StarContainer'

function MostPopular(props) {
    return (
        <div style={{textAlign:'center' , fontSize : '1.2rem'}}>
            Most Popular
            <StarContainer/>
        </div>
    );
}

export default MostPopular;